import { Box, Button, InputLabel, makeStyles, OutlinedInput, Typography } from '@material-ui/core'
import React from 'react'
import Modal from 'react-awesome-modal'
import {Field, Form, Formik, ErrorMessage} from 'formik' 
import { changePasswordSchema } from './modalForms'

const useStyles = makeStyles((theme) => ({
    modalContainer: {
        width: '90%',
        margin: '20px auto'
    },
    modalHeading:{
        fontSize: 24,
        fontWeight: 550,
        marginBottom: 0
    },
    modalLine:{
        margin: '20px auto',
        width: '100%',
        color: theme.palette.secondary.dark
    },
    fieldLabel:{
        color: theme.palette.secondary.light,
        marginBottom: '8px',
        fontSize:'15px',
        fontWeight:500
    },
    inputField:{
        padding: '10px',
        borderRadius: '2px',
    },
    submitBtn:{
        color: theme.palette.secondary.light,
        backgroundColor: theme.palette.primary.main,
        width: 100,
        borderRadius: 2,
        padding: '8px 0',
        '&:hover':{
            backgroundColor: theme.palette.secondary.light,
            color: 'white'
        }
    },
    cancelBtn:{
        backgroundColor: theme.palette.secondary.dark,
        width: 100,
        borderRadius: 2,
        padding: '8px 0',
        color: theme.palette.secondary.light
    }
}))

function ChangePasswordModal(props) {
    const {visible, closeModal} = props
    const classes = useStyles()
    return (
        <Modal visible={visible} width="500" effect="fadeInUp" onClickAway={closeModal}>
            <div className={classes.modalContainer}>
                <h3 className={classes.modalHeading}>Change Password</h3>
                <hr className={classes.modalLine} />
                <Formik
                    initialValues={{
                        password: '',
                        confirmPassword: ''
                    }}
                    onSubmit={(values) => console.log(values)}
                    validationSchema={changePasswordSchema}
                >
                    {({errors}) => {
                        return (
                            <Form>
                                <Box mb={2}>
                                    <InputLabel className={classes.fieldLabel}>Old Password</InputLabel>
                                    <Field type="password" name="password" as={OutlinedInput} fullWidth error={errors.password} className={classes.inputField} />
                                    <ErrorMessage name="password">
                                        {error => <Typography variant="subtitle2" color="error">{error}</Typography>}
                                    </ErrorMessage>
                                </Box>
                                <Box mb={2}>
                                    <InputLabel className={classes.fieldLabel}>Password</InputLabel>
                                    <Field type="password" name="password" as={OutlinedInput} fullWidth error={errors.password} className={classes.inputField} />
                                    <ErrorMessage name="password">
                                        {error => <Typography variant="subtitle2" color="error">{error}</Typography>}
                                    </ErrorMessage>
                                </Box>
                                <Box mb={2}>
                                    <InputLabel className={classes.fieldLabel}>Confirm Password</InputLabel>
                                    <Field type="password" name="confirmPassword" as={OutlinedInput} fullWidth error={errors.confirmPassword} className={classes.inputField} />
                                    <ErrorMessage name="confirmPassword">
                                        {error => <Typography variant="subtitle2" color="error">{error}</Typography>}
                                    </ErrorMessage>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Button className={classes.cancelBtn} onClick={closeModal}>Cancel</Button>
                                    <Button className={classes.submitBtn} type="submit">Update</Button>
                                </Box>
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </Modal>
    )
}

export default ChangePasswordModal
